/** Portal route of a cloud dashboard page (see App.tsx). */
export const dashboardPath = (dashboardId: string) => `/dashboards/${encodeURIComponent(dashboardId)}`
